<app-breadcrumb [master]="'Rejestracje'" [parentName]="'Szkolenia'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group>
  <mat-tab label="Dane">
    <app-idd-trainings-trainer-details-view *ngIf="!modify" [iddTrainingTrainer]="iddTrainingsTrainer"  (modifyClicked)="modify = true"></app-idd-trainings-trainer-details-view>
    <app-add-idd-trainings-trainer *ngIf="modify" [iddTrainingTrainer]="iddTrainingsTrainer"  (closeModification)="modify = false; loadIddTrainingTrainer()"></app-add-idd-trainings-trainer>
  </mat-tab>
  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list  [iddTrainingTrainer]="iddTrainingsTrainer"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>

